import { useTranslation } from "react-i18next";

import { Accordion } from "@aviary";
import { useCatalogSearch } from "@shared/hooks/useCatalogSearch/useCatalogSearch";
import { useSharedGlobalConfig } from "@shared/hooks/useSharedGlobalConfig/useSharedGlobalConfig";
import { l } from "@shared/locales/i18n";

import { FilterTitle } from "../../shared/FilterTitle/FilterTitle";

import { ExcludeIngredientsContent } from "./ExcludeIngredientsContent";

interface Props {
  isBold?: boolean;
  logFilterEvent: (entityName: string, entityType: string) => void;
  isContextual?: boolean;
}

const ExcludeIngredients = ({ isBold, logFilterEvent, isContextual = false }: Props) => {
  const { t } = useTranslation();
  const { excludedIngredients, onlyIngredient } = useCatalogSearch();
  const { isUnauthenticated } = useSharedGlobalConfig();

  if (isUnauthenticated) return null;

  return (
    <Accordion
      coreTriggerContent={
        <FilterTitle
          title={t(l.sharedCatalog.filter.ExcludeIngredients)}
          count={excludedIngredients?.length}
          isSecondaryWeight={isBold}
          isBadge
        />
      }
      isDisabled={onlyIngredient}
    >
      <ExcludeIngredientsContent logFilterEvent={logFilterEvent} isContextual={isContextual} />
    </Accordion>
  );
};

export { ExcludeIngredients };
